/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

// React
import React, { forwardRef, useEffect } from "react";
// form library
import { Controller, useFormContext } from 'react-hook-form';
// material ui components
import TextField from '@mui/material/TextField';
// custom components
import InstructionsArray from "../../instance/course-instruct/InstructionsArray"
import LeadNumberedHeading from "../../../../shared-components/forms/LeadNumberedHeading";
import NumberedHeading from "../../../../shared-components/forms/NumberedHeading";

function BasicInfoForm(props) {
  // get form context
  const methods = useFormContext();
  const { control, formState, getValues, setValue, register } = methods;
  const { errors } = formState;

  return (
    <>
      <LeadNumberedHeading number="1" title="Basic Information" instructions="This information is used to store details about the template." />
      <div className="flex flex-col w-full">
        <NumberedHeading number="1" title="Title" instructions="Enter a title for the template." />
        <Controller
          control={control}
          name="title"
          render={({ field }) => (
            <TextField
              className="mt-16 mb-32"
              {...field}
              label="Title"
              placeholder="Title"
              id="title"
              error={!!errors.title}
              helperText={errors?.title?.message}
              variant="outlined"
              size="small"
              required
              fullWidth
            />
          )}
        />

        <NumberedHeading number="2" title="Label" instructions="Enter a label for the template." />
        <Controller
          control={control}
          name="label"
          render={({ field }) => (
            <TextField
              className="mt-16 mb-32"
              {...field}
              label="Label"
              placeholder="Label"
              id="label"
              error={!!errors.label}
              helperText={errors?.label?.message}
              variant="outlined"
              size="small"
              required
              fullWidth
            />
          )}
        />

        <NumberedHeading number="3" title="Classification" instructions="Enter a classification for the template." />
        <Controller
          control={control}
          name="classification"
          render={({ field }) => (
            <TextField
              className="mt-16 mb-32"
              {...field}
              label="Classification"
              placeholder="Classification"
              id="classification"
              error={!!errors.classification}
              helperText={errors?.classification?.message}
              variant="outlined"
              size="small"
              required
              fullWidth
            />
          )}
        />

        <NumberedHeading number="2" title="Activity Rationale" instructions="Enter a rationale for the template." />
        <Controller
          control={control}
          name="description"
          render={({ field }) => (
            <TextField
              className="mt-16 mb-32"
              {...field}
              label="Activity Rationale"
              placeholder="Activity Rationale"
              id="description"
              error={!!errors.description}
              helperText={errors?.description?.message}
              variant="outlined"
              fullWidth
              multiline
              minRows={5}
              maxRows={10}
              required
            />
          )}
        />

        <NumberedHeading number="3" title="Image" instructions="Enter the image name. Note: this is for the devs." />
        <Controller
          control={control}
          name="image"
          render={({ field }) => (
            <TextField
              className="mt-16 mb-32"
              {...field}
              label="image"
              placeholder="image"
              id="image"
              error={!!errors.image}
              helperText={errors?.image?.message}
              variant="outlined"
              required
              fullWidth
            />
          )}
        />

        <NumberedHeading number="4" title="Instructions" instructions="Provide instructions for the template. Instructions should be provided for each applicable target language." />
        <Controller
          control={control}
          name="instructions"
          render={({ field }) => <InstructionsArray className="mt-16 mb-32" {...{ control, register, getValues, setValue, errors }} />}
        />
      </div>
    </>
  );
};

export default BasicInfoForm;